import { gql } from '@apollo/client';

export const GET_LEADS_WITH_SIMULATIONS_QUERY = gql`
  query GetLeadsWithSimulations($page: Int, $term: String, $limit: Int, $sellerId: ID, $sortParams: String) {
    leadsWithSimulations(page: $page, term: $term, limit: $limit, sellerId: $sellerId, sortParams: $sortParams) {
      page
      total
      limit
      data {
        leadInfo {
          name
          leadId
        }
        proposalsIndexedMetadata {
          favoriteProposalMetadata {
            simulationId
            description
            seller {
              id
              name
              pictureUrl
            }
            createdAt
            economyPercentage
            totalConsumationSummationInMwh
          }
        }
      }
    }
  }
`;
